// UI/UX Glossary Data - Arabic Terms with English Originals
// Organized alphabetically by the ACTUAL first letter of the Arabic term

export const glossaryTerms = [
    // إ (Alif with hamza below)
    {
        id: "accessibility",
        letter: "إ",
        termAr: "إمكانية الوصول",
        termEn: "Accessibility",
        definitionAr: "تصميم المنتجات والخدمات الرقمية بحيث يمكن استخدامها من قبل جميع الأشخاص بما في ذلك ذوي الاحتياجات الخاصة، مثل ضعاف البصر أو السمع أو الحركة.",
    },
    {
        id: "gesture",
        letter: "إ",
        termAr: "إيماءة",
        termEn: "Gesture",
        definitionAr: "حركة تفاعلية يقوم بها المستخدم على الشاشة باللمس مثل السحب، التمرير، توسعة الأصابع للتكبير أو تضييق المسافة للتصغير.",
    },
    {
        id: "wireframe",
        letter: "إ",
        termAr: "إطار سلكي",
        termEn: "Wireframe",
        definitionAr: "رسم تخطيطي مبسط يوضح بنية الصفحة وموضع العناصر دون تفاصيل بصرية.",
    },
    {
        id: "notification",
        letter: "إ",
        termAr: "إشعار",
        termEn: "Notification",
        definitionAr: "رسالة تنبيهية تعلم المستخدم بحدث أو معلومة جديدة مهمة.",
    },

    // أ (Alif with hamza above)
    {
        id: "above-fold",
        letter: "أ",
        termAr: "أعلى الطي",
        termEn: "Above the Fold",
        definitionAr: "الجزء من الصفحة الذي يظهر للمستخدم مباشرة عند فتحها دون الحاجة للتمرير لأسفل.",
    },

    // ا (Alif - plain)
    {
        id: "affordance",
        letter: "إ",
        termAr: "الإيحاء البصري",
        termEn: "Affordance",
        definitionAr: "خاصية العنصر التي توحي بكيفية استخدامه. مثلاً، الزر يبدو قابلاً للنقر، والحقل يبدو قابلاً للكتابة فيه.",
    },
    {
        id: "branding",
        letter: "ه",
        termAr: "الهوية البصرية",
        termEn: "Branding",
        definitionAr: "العناصر المرئية التي تمثل هوية العلامة التجارية مثل الشعار، الألوان، الخطوط، والأسلوب البصري العام.",
    },
    {
        id: "hierarchy",
        letter: "ت",
        termAr: "التسلسل الهرمي",
        termEn: "Visual Hierarchy",
        definitionAr: "ترتيب العناصر بحسب أهميتها باستخدام الحجم، اللون، والموضع لتوجيه انتباه المستخدم.",
    },
    {
        id: "heuristic",
        letter: "ت",
        termAr: "التقييم الاستكشافي",
        termEn: "Heuristic Evaluation",
        definitionAr: "طريقة لتقييم قابلية استخدام الواجهة من خلال مراجعتها مقابل مجموعة من المبادئ المعترف بها.",
    },
    {
        id: "typography",
        letter: "ط",
        termAr: "الطباعة",
        termEn: "Typography",
        definitionAr: "فن وتقنية ترتيب الحروف والنصوص لجعل اللغة المكتوبة واضحة وجذابة ومريحة للقراءة.",
    },
    {
        id: "scroll",
        letter: "ت",
        termAr: "التمرير",
        termEn: "Scroll",
        definitionAr: "الحركة العمودية أو الأفقية عبر المحتوى لعرض الأجزاء غير المرئية من الصفحة.",
    },
    {
        id: "navigation",
        letter: "ت",
        termAr: "التنقل",
        termEn: "Navigation",
        definitionAr: "نظام يساعد المستخدمين في التحرك بين الصفحات والأقسام المختلفة في الموقع.",
    },
    {
        id: "responsive",
        letter: "ت",
        termAr: "التصميم المتجاوب",
        termEn: "Responsive Design",
        definitionAr: "نهج في التصميم يجعل صفحات الويب تعرض بشكل جيد على مختلف الأجهزة وأحجام الشاشات.",
    },
    {
        id: "loading",
        letter: "ت",
        termAr: "التحميل",
        termEn: "Loading State",
        definitionAr: "مؤشر بصري يخبر المستخدم أن العملية جارية ويجب الانتظار.",
    },
    {
        id: "contrast",
        letter: "ت",
        termAr: "التباين",
        termEn: "Contrast",
        definitionAr: "الفرق بين درجتي لونين، مهم للوضوح وإمكانية القراءة خاصة للنصوص.",
    },
    {
        id: "spacing",
        letter: "ت",
        termAr: "التباعد",
        termEn: "Spacing",
        definitionAr: "المسافات بين العناصر المختلفة التي تساعد في الوضوح وسهولة القراءة.",
    },
    {
        id: "micro-interaction",
        letter: "ت",
        termAr: "التفاعلات الدقيقة",
        termEn: "Micro-interaction",
        definitionAr: "تفاعلات صغيرة ولحظية تحدث استجابة لفعل المستخدم، تعزز تجربة الاستخدام.",
    },
    {
        id: "animation",
        letter: "ر",
        termAr: "الرسوم المتحركة",
        termEn: "Animation",
        definitionAr: "الحركة أو التأثيرات الانتقالية للعناصر التي تحسن التفاعل وتوجه انتباه المستخدم.",
    },
    {
        id: "dark-mode",
        letter: "و",
        termAr: "الوضع الداكن",
        termEn: "Dark Mode",
        definitionAr: "نمط عرض يستخدم خلفية داكنة ونصوص فاتحة لتقليل إجهاد العين وتوفير الطاقة.",
    },
    {
        id: "white-space",
        letter: "م",
        termAr: "المساحة البيضاء",
        termEn: "White Space",
        definitionAr: "المناطق الفارغة في التصميم التي تساعد على التركيز وتحسين القراءة.",
    },
    {
        id: "hero-section",
        letter: "ق",
        termAr: "القسم الرئيسي",
        termEn: "Hero Section",
        definitionAr: "القسم البارز في أعلى الصفحة الرئيسية يحتوي على رسالة رئيسية وصورة جذابة.",
    },

    // ب (Ba)
    {
        id: "card",
        letter: "ب",
        termAr: "بطاقة",
        termEn: "Card",
        definitionAr: "حاوية مستطيلة تجمع معلومات مرتبطة ببعضها في وحدة واحدة قابلة للنقر أو التفاعل.",
    },

    // ت (Ta)
    {
        id: "tooltip",
        letter: "ت",
        termAr: "تلميح أدوات",
        termEn: "Tooltip",
        definitionAr: "رسالة صغيرة تظهر عند تمرير المؤشر فوق عنصر معين لتقديم معلومات إضافية أو توضيحية.",
    },
    {
        id: "tabs",
        letter: "ت",
        termAr: "تبويبات",
        termEn: "Tabs",
        definitionAr: "عناصر ملاحية تنظم المحتوى في أقسام منفصلة يمكن التبديل بينها دون مغادرة الصفحة.",
    },
    {
        id: "footer",
        letter: "ت",
        termAr: "تذييل الصفحة",
        termEn: "Footer",
        definitionAr: "القسم السفلي من الصفحة الذي يحتوي عادة على روابط مهمة ومعلومات الاتصال وحقوق النشر.",
    },
    {
        id: "layout",
        letter: "ت",
        termAr: "تخطيط",
        termEn: "Layout",
        definitionAr: "الطريقة التي يتم بها ترتيب وتنظيم العناصر على الصفحة أو الشاشة.",
    },
    {
        id: "ux",
        letter: "ت",
        termAr: "تجربة المستخدم",
        termEn: "UX (User Experience)",
        definitionAr: "التجربة الكلية للمستخدم عند استخدام المنتج، تشمل سهولة الاستخدام والرضا العام.",
    },

    // ح (Ha)
    {
        id: "hover-state",
        letter: "ح",
        termAr: "حالة المرور",
        termEn: "Hover State",
        definitionAr: "التغيير البصري الذي يحدث عند تمرير مؤشر الفأرة فوق عنصر تفاعلي، يوضح أنه قابل للنقر.",
    },
    {
        id: "focus-state",
        letter: "ح",
        termAr: "حالة التركيز",
        termEn: "Focus State",
        definitionAr: "المظهر البصري للعنصر عندما يكون نشطاً ويتلقى إدخالات لوحة المفاتيح.",
    },

    // ر (Ra)
    {
        id: "header",
        letter: "ر",
        termAr: "رأس الصفحة",
        termEn: "Header",
        definitionAr: "القسم العلوي من الصفحة الذي يحتوي عادة على الشعار وقائمة التنقل الرئيسية.",
    },
    {
        id: "link",
        letter: "ر",
        termAr: "رابط",
        termEn: "Link",
        definitionAr: "نص أو عنصر قابل للنقر ينقل المستخدم إلى صفحة أخرى أو قسم آخر.",
    },

    // ز (Zay)
    {
        id: "button",
        letter: "ز",
        termAr: "زر",
        termEn: "Button",
        definitionAr: "عنصر تفاعلي قابل للنقر يستخدم لتنفيذ إجراء معين مثل الإرسال، الحفظ، أو الانتقال لصفحة أخرى.",
    },
    {
        id: "radio-button",
        letter: "ز",
        termAr: "زر راديو",
        termEn: "Radio Button",
        definitionAr: "عنصر تحكم يسمح للمستخدم باختيار خيار واحد فقط من مجموعة خيارات متعددة.",
    },

    // ش (Shin)
    {
        id: "grid",
        letter: "ش",
        termAr: "شبكة التصميم",
        termEn: "Grid System",
        definitionAr: "نظام من الخطوط الأفقية والعمودية المتقاطعة يساعد في تنظيم وترتيب العناصر بشكل متسق ومتناسق.",
    },
    {
        id: "sidebar",
        letter: "ش",
        termAr: "شريط جانبي",
        termEn: "Sidebar",
        definitionAr: "منطقة عمودية على جانب الصفحة تحتوي عادة على روابط ملاحية أو معلومات إضافية.",
    },
    {
        id: "navbar",
        letter: "ش",
        termAr: "شريط التنقل",
        termEn: "Navigation Bar",
        definitionAr: "شريط يحتوي على روابط رئيسية للتنقل في الموقع، عادة في أعلى الصفحة.",
    },
    {
        id: "slider",
        letter: "ش",
        termAr: "شريط منزلق",
        termEn: "Slider",
        definitionAr: "عنصر تحكم يسمح للمستخدم باختيار قيمة من نطاق معين عن طريق سحب مؤشر على خط.",
    },
    {
        id: "search-bar",
        letter: "ش",
        termAr: "شريط البحث",
        termEn: "Search Bar",
        definitionAr: "حقل إدخال مخصص للبحث عن محتوى معين داخل الموقع أو التطبيق.",
    },
    {
        id: "screen",
        letter: "ش",
        termAr: "شاشة",
        termEn: "Screen",
        definitionAr: "صفحة أو واجهة كاملة ضمن التطبيق أو الموقع تعرض محتوى أو وظيفة معينة.",
    },
    {
        id: "skeleton-screen",
        letter: "ش",
        termAr: "شاشة هيكلية",
        termEn: "Skeleton Screen",
        definitionAr: "نمط تحميل يعرض إطار المحتوى قبل ظهوره الكامل لتحسين الإحساس بالأداء.",
    },

    // ع (Ain)
    {
        id: "ui-elements",
        letter: "ع",
        termAr: "عناصر الواجهة",
        termEn: "UI Elements",
        definitionAr: "المكونات المرئية في الواجهة مثل الأزرار، القوائم، الحقول، والأيقونات التي يتفاعل معها المستخدم.",
    },

    // ف (Fa)
    {
        id: "filter",
        letter: "ف",
        termAr: "فلتر",
        termEn: "Filter",
        definitionAr: "أداة تسمح للمستخدمين بتضييق نطاق النتائج أو المحتوى بناءً على معايير محددة.",
    },

    // ق (Qaf)
    {
        id: "hamburger-menu",
        letter: "ق",
        termAr: "قائمة همبرجر",
        termEn: "Hamburger Menu",
        definitionAr: "أيقونة تتكون من ثلاثة خطوط أفقية تستخدم لإخفاء/إظهار القائمة الرئيسية خاصة على الأجهزة المحمولة.",
    },
    {
        id: "dropdown",
        letter: "ق",
        termAr: "قائمة منسدلة",
        termEn: "Dropdown Menu",
        definitionAr: "قائمة من الخيارات تظهر عند النقر على عنصر معين، تستخدم لحفظ مساحة الواجهة.",
    },
    {
        id: "menu",
        letter: "ق",
        termAr: "قائمة",
        termEn: "Menu",
        definitionAr: "قائمة من الخيارات أو الروابط التي تساعد المستخدم في التنقل عبر التطبيق.",
    },
    {
        id: "usability",
        letter: "ق",
        termAr: "قابلية الاستخدام",
        termEn: "Usability",
        definitionAr: "مدى سهولة وفعالية استخدام المنتج لتحقيق أهداف المستخدم.",
    },

    // م (Mim)
    {
        id: "breadcrumb",
        letter: "م",
        termAr: "مسار التنقل",
        termEn: "Breadcrumb",
        definitionAr: "عنصر ملاحي يوضح للمستخدم موقعه الحالي ضمن هيكل الموقع ويسمح له بالرجوع للصفحات السابقة.",
    },
    {
        id: "user-flow",
        letter: "م",
        termAr: "مسار المستخدم",
        termEn: "User Flow",
        definitionAr: "المسار الذي يتبعه المستخدم خلال التطبيق لإتمام مهمة معينة.",
    },
    {
        id: "checkbox",
        letter: "م",
        termAr: "مربع اختيار",
        termEn: "Checkbox",
        definitionAr: "عنصر تحكم يسمح للمستخدم باختيار خيار واحد أو أكثر من مجموعة خيارات.",
    },
    {
        id: "toggle",
        letter: "م",
        termAr: "مفتاح التبديل",
        termEn: "Toggle",
        definitionAr: "عنصر تحكم يسمح للمستخدم بالتبديل بين حالتين (مثل تشغيل/إيقاف).",
    },
    {
        id: "typography-scale",
        letter: "م",
        termAr: "مقياس الطباعة",
        termEn: "Typography Scale",
        definitionAr: "نظام متدرج لأحجام الخطوط يضمن التناسق والتسلسل الهرمي الواضح في النصوص.",
    },
    {
        id: "component",
        letter: "م",
        termAr: "مكون",
        termEn: "Component",
        definitionAr: "وحدة بناء قابلة لإعادة الاستخدام في واجهة المستخدم مثل الزر أو البطاقة.",
    },

    // ن (Nun)
    {
        id: "breakpoint",
        letter: "ن",
        termAr: "نقطة التحول",
        termEn: "Breakpoint",
        definitionAr: "نقطة محددة في عرض الشاشة يتغير عندها تخطيط الصفحة ليتناسب مع حجم الجهاز (موبايل، تابلت، ديسكتوب).",
    },
    {
        id: "modal",
        letter: "ن",
        termAr: "نافذة منبثقة",
        termEn: "Modal",
        definitionAr: "نافذة حوارية تظهر فوق المحتوى الرئيسي وتتطلب تفاعل المستخدم قبل العودة للصفحة.",
    },
    {
        id: "design-system",
        letter: "ن",
        termAr: "نظام التصميم",
        termEn: "Design System",
        definitionAr: "مجموعة شاملة من المعايير، المكونات، والأنماط القابلة لإعادة الاستخدام لضمان اتساق التصميم عبر المنتج.",
    },
    {
        id: "form",
        letter: "ن",
        termAr: "نموذج",
        termEn: "Form",
        definitionAr: "مجموعة من حقول الإدخال التي تجمع معلومات من المستخدم مثل نماذج التسجيل أو الاتصال.",
    },
    {
        id: "mockup",
        letter: "ن",
        termAr: "نموذج مرئي",
        termEn: "Mockup",
        definitionAr: "تمثيل ثابت عالي الدقة للتصميم النهائي يوضح الألوان والخطوط والعناصر.",
    },

    // هـ (Ha)
    {
        id: "margin",
        letter: "هـ",
        termAr: "هامش خارجي",
        termEn: "Margin",
        definitionAr: "المسافة الخارجية حول العنصر التي تفصله عن العناصر المجاورة.",
    },

    // و (Waw)
    {
        id: "ui",
        letter: "و",
        termAr: "واجهة المستخدم",
        termEn: "UI (User Interface)",
        definitionAr: "كل ما يتفاعل معه المستخدم بصرياً في المنتق الرقمي من أزرار وقوائم وألوان.",
    },
    {
        id: "widget",
        letter: "و",
        termAr: "ودجت",
        termEn: "Widget",
        definitionAr: "عنصر تفاعلي صغير ومستقل يؤدي وظيفة محددة ضمن الواجهة.",
    },
];

// Get unique Arabic letters from the glossary
export const arabicLetters = [
    "أ", "إ", "ا", "ب", "ت", "ث", "ج", "ح", "خ", "د", "ذ", "ر", "ز", "س", "ش", "ص", "ض", "ط", "ظ", "ع", "غ", "ف", "ق", "ك", "ل", "م", "ن", "هـ", "و", "ي"
];

// Get terms by letter
export function getTermsByLetter(letter) {
    if (!letter) return glossaryTerms;
    return glossaryTerms.filter(term => term.letter === letter);
}

// Get all letters that have terms
export function getAvailableLetters() {
    const letters = new Set(glossaryTerms.map(term => term.letter));
    return arabicLetters.filter(letter => letters.has(letter));
}
